module.exports = __webpack_public_path__ + "img/avatardefault.739297c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/avatardefault.png
// module id = dpiD
// module chunks = 20